import React from 'react';
import { useFormikContext } from 'formik';
import { Show } from 'components/shared/Show';
import { css } from '@/styled-system/css';
import { Button } from '@zillow/constellation-10';

export const NotaryStepNavigation: React.FC<{ advance: () => void; goBack: () => void; isDigSync?: boolean }> = ({
  advance,
  goBack,
  isDigSync,
}) => {
  const { isValid } = useFormikContext();
  return (
    <section className={css({ marginTop: '16', display: 'flex', justifyContent: 'space-between' })}>
      <Button tone={'brand'} emphasis={'outlined'} size="sm" onClick={goBack}>
        Back
      </Button>
      <div className={css({ display: 'flex' })}>
        <Show when={!isDigSync}>
          <div
            onClick={advance}
            className={css({ marginRight: '16', cursor: 'pointer', paddingTop: '8', paddingBottom: '8' })}
          >
            Add Notary Later
          </div>
        </Show>
        <Button tone={'brand'} emphasis={'filled'} size="sm" type="submit" disabled={!isValid}>
          Next
        </Button>
      </div>
    </section>
  );
};
